import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ATMOnSiteIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ATMOnSiteIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M9.61326 7.36946C9.61158 7.36501 9.60982 7.36055 9.60803 7.35618C9.5208 7.14411 9.31631 7.00719 9.08697 7.00719C8.8574 7.00739 8.6524 7.14473 8.56552 7.35711C8.564 7.36078 8.56255 7.36449 8.56111 7.36816L7.32904 10.6016C7.23291 10.8539 7.35959 11.1363 7.61197 11.2324C7.86443 11.3285 8.14689 11.2018 8.24306 10.9496L8.41829 10.4897H9.74595L9.91908 10.9482C9.99299 11.1439 10.1791 11.2645 10.3767 11.2645C10.4341 11.2645 10.4924 11.2543 10.5493 11.2329C10.802 11.1376 10.9295 10.8556 10.8341 10.603L9.61326 7.36946ZM8.7908 9.51212L9.08518 8.73958L9.37686 9.51212H8.7908Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.3114 7.46352L17.3103 7.4577C17.2593 7.20739 17.0454 7.0225 16.7902 7.00809C16.5347 6.99329 16.3017 7.15332 16.2228 7.39637C16.221 7.40196 16.2193 7.40758 16.2177 7.41325L15.7045 9.21263L15.1719 7.40841C15.1702 7.40259 15.1684 7.39685 15.1664 7.39114C15.085 7.14883 14.8494 6.99137 14.5949 7.00868C14.3398 7.02575 14.1279 7.21298 14.0796 7.46392L14.0786 7.46947L13.5019 10.6632C13.4539 10.9289 13.6304 11.1831 13.8962 11.2311C14.1619 11.2789 14.4164 11.1025 14.4644 10.8369L14.73 9.36592L15.172 10.8635C15.1737 10.8692 15.1755 10.8749 15.1774 10.8807C15.2546 11.1105 15.4689 11.2644 15.7113 11.2644H15.7142C15.9577 11.2632 16.1718 11.1068 16.247 10.8753C16.2488 10.8697 16.2505 10.8641 16.2521 10.8584L16.6787 9.36248L16.9616 10.8417C17.0122 11.1069 17.2683 11.2808 17.5337 11.2301C17.799 11.1794 17.973 10.9234 17.9222 10.6582L17.3114 7.46352Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.878 7.00719H11.066C10.7959 7.00719 10.5769 7.22602 10.5769 7.49598C10.5769 7.76594 10.7959 7.98477 11.066 7.98477H11.4793V10.7756C11.4793 11.0456 11.6983 11.2644 11.9683 11.2644C12.2384 11.2644 12.4574 11.0455 12.4574 10.7756V7.98477H12.878C13.1481 7.98477 13.3671 7.76594 13.3671 7.49598C13.3671 7.22606 13.1481 7.00719 12.878 7.00719Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M22.0431 2H3.21672C2.89262 2 2.62988 2.26262 2.62988 2.58656V20.2356C2.62988 20.5595 2.89261 20.8221 3.21672 20.8221H4.97723V21.4135C4.97723 21.7374 5.23996 22 5.56407 22C5.88818 22 6.15091 21.7374 6.15091 21.4135V16.0848H7.32458V21.4135C7.32458 21.7374 7.58731 22 7.91142 22C8.23553 22 8.49826 21.7374 8.49826 21.4135V16.0848H12.015V21.4135C12.015 21.7374 12.2777 22 12.6018 22C12.9259 22 13.1886 21.7374 13.1886 21.4135V20.8221H22.0431C22.3672 20.8221 22.6299 20.5595 22.6299 20.2356V2.58656C22.6299 2.26261 22.3672 2 22.0431 2ZM21.4562 19.649H13.1886V15.4983C13.1886 15.1743 12.9259 14.9117 12.6018 14.9117H5.56406C5.23996 14.9117 4.97722 15.1743 4.97722 15.4983V19.649H3.80355V3.17312H21.4562L21.4562 19.649Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M5.56407 13.6661H19.6566C19.9807 13.6661 20.2435 13.4035 20.2435 13.0796V4.93277C20.2435 4.60882 19.9807 4.34621 19.6566 4.34621H5.56407C5.23997 4.34621 4.97723 4.60883 4.97723 4.93277V13.0796C4.97723 13.4035 5.23996 13.6661 5.56407 13.6661ZM6.15091 5.5193H19.0698V12.493H6.15091V5.5193Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.1325 17.6201C18.9689 17.9977 19.2634 18.4363 19.6744 18.4311C20.0857 18.4359 20.3789 17.9981 20.2162 17.6201C20.0181 17.1403 19.3303 17.1399 19.1325 17.6201Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M16.7852 17.6201C16.6215 17.9978 16.9161 18.4362 17.3271 18.4311C17.7384 18.4359 18.0316 17.9982 17.8689 17.6201C17.6708 17.1403 16.9829 17.1398 16.7852 17.6201Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4379 17.6201C14.2742 17.9979 14.5687 18.4361 14.9797 18.4311C15.3911 18.4357 15.6842 17.9983 15.5216 17.6201C15.3234 17.1403 14.6355 17.1399 14.4379 17.6201Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.1325 15.2738C18.9689 15.6514 19.2634 16.09 19.6744 16.0849C20.0857 16.0896 20.3789 15.6518 20.2162 15.2739C20.0181 14.7941 19.3303 14.7937 19.1325 15.2738Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.3271 16.0849C17.7383 16.0897 18.0316 15.6517 17.8689 15.2739C17.6709 14.7942 16.9827 14.7938 16.7852 15.2739C16.6215 15.6514 16.9161 16.0901 17.3271 16.0849Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.4379 15.2738C14.2742 15.6515 14.5687 16.0901 14.9797 16.0849C15.391 16.0897 15.6842 15.6518 15.5216 15.2739C15.3235 14.7942 14.6355 14.7938 14.4379 15.2738Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ATMOnSiteIcon;
